import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronDownSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.3536 12.9395C12.1583 13.1348 11.8417 13.1348 11.6464 12.9395L8.35355 9.6466C8.15829 9.45133 7.84171 9.45133 7.64645 9.6466C7.45118 9.84186 7.45118 10.1584 7.64645 10.3537L10.9393 13.6466C11.5251 14.2324 12.4749 14.2324 13.0607 13.6466L16.3536 10.3537C16.5488 10.1584 16.5488 9.84186 16.3536 9.6466C16.1583 9.45133 15.8417 9.45133 15.6464 9.6466L12.3536 12.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownSmall;
